import { CheckmarkCircleFilledIcon, EditIcon, TimeFilledIcon } from '@calizahq/react-components-v2'
import React from 'react'

import { BottomSheet, History } from '@/components'
import { RecordType } from '@/graphql/queries/fieldHistoryLogs/fieldHistoryLogs.queries'
import { useToggle } from '@/hooks'
import { ScheduledCommunicationTemplateList } from '@/types/ScheduledCommunicationTemplate'

import { EditScheduledCommunicationTemplateForm } from '../ScheduledCommunicationTemplateForms/EditScheduledCommunicationTemplateForm'

export const ScheduledCommunicationTemplateListColumns = (refetchOnSuccess: () => void) => {
  return [
    {
      Header: 'Active',
      accessor: 'active',
      width: 25,
      canResize: false,
      Cell: ({ value }: { value: string }) => {
        return (
          <CheckmarkCircleFilledIcon
            className={`mr-3 ${value ? 'text-green-300' : 'icon-tertiary'}`}
            height={28}
            width={28}
          />
        )
      },
    },
    {
      Header: 'Market Segment',
      accessor: 'marketSegment',
      width: 40,
      disableSortBy: true,
    },
    {
      Header: 'Scheduled Communication Type',
      accessor: 'scheduledCommunicationType',
      width: 40,
      disableSortBy: true,
    },
    {
      Header: 'Content',
      accessor: 'content',
      width: 40,
      disableSortBy: true,
    },
    {
      accessor: 'id',
      width: 25,
      canResize: false,
      Cell: ({ row }: { row: { original: ScheduledCommunicationTemplateList } }) => {
        const { isShown: editModalShown, toggle: editModalToggle } = useToggle()
        const { isShown: historyModalShown, toggle: historyModalToggle } = useToggle()

        return (
          <>
            <button
              className={'ml-2 mr-2 grid h-5 w-5 items-center justify-center'}
              onClick={editModalToggle}
              title="Edit Scheduled Communication Template"
            >
              <EditIcon className="text-green-300" width={16} />
            </button>
            <button
              className="mr-2 grid h-5 w-5 items-center justify-center"
              onClick={historyModalToggle}
              title="View History"
            >
              <TimeFilledIcon className="w-5 cursor-pointer text-green-300" />
            </button>
            <BottomSheet isVisible={editModalShown} mobileFullHeight={true} onClose={editModalToggle}>
              <EditScheduledCommunicationTemplateForm
                refetchOnSuccess={refetchOnSuccess}
                scheduledCommunicationTemplate={row.original}
                toggle={editModalToggle}
              />
            </BottomSheet>
            {historyModalShown ? (
              <BottomSheet isVisible={historyModalShown} mobileFullHeight={true} onClose={historyModalToggle}>
                <History recordId={row.original.id} recordType={RecordType.SCHEDULED_COMMUNICATION_TEMPLATES} />
              </BottomSheet>
            ) : null}
          </>
        )
      },
    },
  ]
}
